import React from 'react';
import AccordionSection from '../shared/AccrodionSection';
import { Box, Grid2 as Grid } from '@mui/material';
import { ShowPageLayout } from 'framework/ui/layout';
import PeopleManagementSection from './Show/PeopleManagementSection';
import HRManagementSection from './Show/HRManagementSection';
import MentorshipSection from './Show/MentorshipSection';
import DavinciSupportSection from './Show/DavinciSupportSection';

const cardSx = {
  display: 'flex',
  border: '1px solid lightgrey',
  borderRadius: 1,
  p: 3,
};

const ContactsSection = React.memo(() => {
  return (
    <Box sx={{ '& > .MuiPaper-root': { minHeight: 'unset' } }}>
      <ShowPageLayout minHeight="100px">
        <AccordionSection title="My contacts" lazyLoad>
          <Grid container rowSpacing={2} columnSpacing={1} alignItems="stretch">
            <Grid size={{ xs: 12, md: 6 }} sx={cardSx}>
              <PeopleManagementSection />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={cardSx}>
              <HRManagementSection />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={cardSx}>
              <MentorshipSection />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={cardSx}>
              <DavinciSupportSection />
            </Grid>
          </Grid>
        </AccordionSection>
      </ShowPageLayout>
    </Box>
  );
});

export default ContactsSection;
